import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class ControlService {
    public url: string;
    public controller: string;
    public fuente: string;
    constructor(
        private _http: HttpClient
    ) {
        this.url = environment.urlApi;
        this.controller = 'reference/';
        this.fuente = 'Source/';
    }
    getControl(): Observable<any> {
        const json = this._http.get(this.url + this.controller+'controles');
        return json;
    }
    getEquiposByControl(id): Observable<any> {
        const json = this._http.get(this.url + this.controller+'Equipos/ByControl/' + id);
        return json;
    }
    getControlByEquipos(id): Observable<any> {
        const json = this._http.get(this.url + this.controller+'Equipos/ByControl/' + id);
        return json;
    }

    getEquipos(): Observable<any> {
        const json = this._http.get(this.url + this.controller+'Equipos/');
        return json;
    }

    getModelos(): Observable<any> {
        const json = this._http.get(this.url + this.fuente+'Modelos/');
        return json;
    }

    getAccesorioByModelos(id): Observable<any> {
        const json = this._http.get(this.url + this.fuente+'Accesorios/ByModelo/' + id);
        return json;
    }
}